import createIcon from '../../createIcon';

/**
 * @component @name MediaBluetoothOn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAzTDkuMDEgMTMuNTVDOC40MSAxMy4yMSA3LjczIDEzIDcuMDEgMTNDNC43OSAxMyAzIDE0Ljc5IDMgMTdDMyAxOS4yMSA0Ljc5IDIxIDcuMDEgMjFDOS4yMyAyMSAxMSAxOS4yMSAxMSAxN1Y3SDE1VjNIOVpNMjEgMTIuNDNMMTcuNTcgOUgxNi45N1YxMy41NUwxNC4yMiAxMC44TDEzLjM3IDExLjY1TDE2LjczIDE1TDEzLjM4IDE4LjM1TDE0LjIzIDE5LjJMMTYuOTggMTYuNDVWMjFIMTcuNThMMjEgMTcuNTdMMTguNDIgMTVMMjEgMTIuNDNaTTE4LjE3IDExLjNMMTkuMyAxMi40M0wxOC4xNyAxMy41NlYxMS4zWk0xOS4zIDE3LjU3TDE4LjE3IDE4LjdWMTYuNDRMMTkuMyAxNy41N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MediaBluetoothOn = createIcon('MediaBluetoothOn', [
  [
    'path',
    {
      d: 'M9 3L9.01 13.55C8.41 13.21 7.73 13 7.01 13C4.79 13 3 14.79 3 17C3 19.21 4.79 21 7.01 21C9.23 21 11 19.21 11 17V7H15V3H9ZM21 12.43L17.57 9H16.97V13.55L14.22 10.8L13.37 11.65L16.73 15L13.38 18.35L14.23 19.2L16.98 16.45V21H17.58L21 17.57L18.42 15L21 12.43ZM18.17 11.3L19.3 12.43L18.17 13.56V11.3ZM19.3 17.57L18.17 18.7V16.44L19.3 17.57Z',
      key: '9ygdtf',
    },
  ],
]);

export default MediaBluetoothOn;
